import { ComponentProps, FC } from "react";

import { Box } from "@mui/material";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

type DecorativeLottieProps = ComponentProps<typeof Lottie>;

export const DecorativeLottie: FC<DecorativeLottieProps> = (props) => (
  <Box component="span" inert aria-hidden sx={{ display: "contents" }}>
    <Lottie {...props} />
  </Box>
);
